import cloneDeep from 'lodash.clonedeep';
import { useContext, useEffect } from 'react';

import { useGame } from '../hooks/use-game';
import { GameStatus } from '../types/state';
import { GameContext } from '../contexts/game';
import { TeamStateProvider } from '../contexts/team';
import { Outlet, useParams } from 'react-router-dom';
import { OverlayProvider } from '../contexts/overlay';
import { TradeStateProvider } from '../contexts/trade';
import { useVersionInfo } from '../contexts/version-info';
import { PlayerChatProvider } from '../contexts/player-chat';
import { AllTimerEvents } from '../components/timer/runtime';
import { AchievementProvider } from '../contexts/achievement';
import { NotificationProvider } from '../contexts/notification';
import { GameDocumentContext } from '../contexts/game-document';
import { QueueCommandProvider } from '../contexts/queue-handler';
import { UpdateGameStateAsync } from '../utils/game-engine/base';
import { useUploadOnBackground } from '../hooks/use-upload-on-background';
import { useScoringOnBackground } from '../hooks/use-scoring-on-background';

/**
 * The layout for in-game screens.
 */
export const InGameLayout = () => {
  const { gameCode } = useParams();
  const [, setGameState] = useContext(GameContext);
  const { data: gameData } = useGame(gameCode!);

  useUploadOnBackground();
  useScoringOnBackground();

  useEffect(() => {
    if (gameData && gameData.gameStatus) {
      setGameState((prev) =>
        UpdateGameStateAsync(
          prev,
          cloneDeep({
            ...prev.gameState!,
            status: gameData?.gameStatus! as GameStatus
          })
        )
      );
    }
  }, [gameData?.gameStatus, setGameState]);

  const { setLoadedGameDocumentVersion } = useVersionInfo();
  const [gameState] = useContext(GameDocumentContext);

  useEffect(() => {
    const gameDocument = gameState?.gameDocument;

    if (!gameState || !gameDocument) {
      return;
    }

    setLoadedGameDocumentVersion(gameDocument.version);

    // Cleanup/reset
    return () => {
      setLoadedGameDocumentVersion(null);
    };
  }, [setLoadedGameDocumentVersion, gameState?.gameDocument?.version]);

  return (
    <QueueCommandProvider gameCode={gameCode!}>
      <TeamStateProvider gameCode={gameCode!}>
        <NotificationProvider>
          <AchievementProvider>
            <div className={'layout layout--in-game'}>
              {/* <OfflineOverlay /> */}
              <div className={'layout__container'}>
                <PlayerChatProvider>
                  <TradeStateProvider gameCode={gameCode!}>
                    <OverlayProvider>
                      <div className={'game__canvas'}>
                        <AllTimerEvents />
                        <Outlet />
                      </div>
                    </OverlayProvider>
                  </TradeStateProvider>
                </PlayerChatProvider>
              </div>
            </div>
          </AchievementProvider>
        </NotificationProvider>
      </TeamStateProvider>
    </QueueCommandProvider>
  );
};

export default InGameLayout;
